var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import salesLeadUrlConfig from "@adapters/infrastructures/urlConfig/SalesJourney/Profile/SalesLeadPageURL";
import leadUrlConfig from "@adapters/infrastructures/urlConfig/SalesJourney/Lead/LeadURL";
import { validateOtpMapper } from "@domains/salesFeatures/Lead/mapper/ValidateOtpMapper";
import { ClientProfileDetailsMapper } from "@domains/salesFeatures/Lead/mapper/ClientDetailsMapper";
import { LeadOtpMapper } from "@domains/salesFeatures/Lead/mapper/LeadOtpMapper";
import { SearchLeadMapper } from "@domains/salesFeatures/Lead/mapper/SearchLeadMapper";
import { internalCommentMapper } from "@domains/salesFeatures/Lead/mapper/InternalCommants";
import { leadLogsMapper } from "@domains/salesFeatures/Lead/mapper/leadLogMapper";
import { leadPastInteractions } from "@domains/salesFeatures/Lead/mapper/LeadPastInteractionMapper";
import { SelfAssignMapper } from "@domains/salesFeatures/Lead/mapper/SelfAssignMapper";
import { generateHashForHmacSHA256, generateRandomString, genericDecrypt, genericEncrypt, } from "@domains/utils/encryption";
import { removeObjectValues } from "@frameworks/salesjourney/components/Features/LeadDashboard/constant";
import { CriticalPriorityAgingMapper } from "@domains/salesFeatures/Lead/mapper/CriticalPriorityAging";
import { partnerCodeMapper } from "@domains/salesFeatures/Lead/mapper/PartnerCodeMapper";
import { SBCodeMasterMapper } from "@domains/salesFeatures/Lead/mapper/SBCodeMasterMapper";
import { DIYSearchAOPLeadDetailsMapper } from "@domains/salesFeatures/Lead/mapper/DIYSearchAOPLeadDetailsMapper";
import { leadStatusConfig } from "@frameworks/salesjourney/utils/commonLeadStatusConfig";
import { countryListMapper } from "@domains/salesFeatures/Lead/mapper/CountryListMapper";
import { momAttachFilesMapper } from "@domains/salesFeatures/Lead/mapper/MomAttachFilesMapper";
var LeadRepository = /** @class */ (function () {
    function LeadRepository(http) {
        this.http = http;
    }
    LeadRepository.prototype.getCountryList = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, headers, respData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.getCountryCodesList);
                        headers = new Headers();
                        headers.append("ApiKey", leadStatusConfig.ApiKey);
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                headers: headers,
                            })];
                    case 1:
                        respData = _a.sent();
                        return [2 /*return*/, countryListMapper(respData)];
                }
            });
        });
    };
    LeadRepository.prototype.searchProductByIssureName = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, respData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(leadUrlConfig.searchProductByIssuerName);
                        url.searchParams.append("bucketId", (req === null || req === void 0 ? void 0 : req.bucketId) ? req.bucketId.toString() : "0");
                        url.searchParams.append("productId", (req === null || req === void 0 ? void 0 : req.productId) ? req.productId.toString() : "0");
                        url.searchParams.append("catId", (req === null || req === void 0 ? void 0 : req.catId) ? req.catId.toString() : "0");
                        url.searchParams.append("page", (req === null || req === void 0 ? void 0 : req.page) ? req.page.toString() : "1");
                        url.searchParams.append("pageSize", (req === null || req === void 0 ? void 0 : req.pageSize) ? req.pageSize.toString() : "100");
                        req.searchText && url.searchParams.append("searchText", req.searchText);
                        if (req === null || req === void 0 ? void 0 : req.focus)
                            url.searchParams.append("focus", (_a = req.focus) === null || _a === void 0 ? void 0 : _a.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        respData = _b.sent();
                        return [2 /*return*/, respData];
                }
            });
        });
    };
    LeadRepository.prototype.getCategorySubCategoryByIssuerName = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.getCategorySubCategoryByIssuerName);
                        url.searchParams.append("issuerId", req.issuerId);
                        if (req === null || req === void 0 ? void 0 : req.categoryid) {
                            url.searchParams.append("categoryid", req.categoryid.toString());
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LeadRepository.prototype.verificationLink = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, headers, respData, sendVerificationLinkEntity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.verificationLink);
                        headers = new Headers();
                        headers.append("ApiKey", leadStatusConfig.ApiKey);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                headers: headers,
                            })];
                    case 1:
                        respData = _a.sent();
                        sendVerificationLinkEntity = {};
                        if (respData != null && respData !== undefined) {
                            sendVerificationLinkEntity = respData;
                        }
                        return [2 /*return*/, sendVerificationLinkEntity];
                }
            });
        });
    };
    LeadRepository.prototype.getRemappingClientTaskCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, respData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.remappingClientTaskCount);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        respData = _a.sent();
                        return [2 /*return*/, respData];
                }
            });
        });
    };
    LeadRepository.prototype.getFollowUpAgingRMs = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, respData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.followUpAging);
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        respData = _a.sent();
                        return [2 /*return*/, respData];
                }
            });
        });
    };
    LeadRepository.prototype.getPipelineAgingLeadCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, respData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.pipelineAgingLeadCount);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        respData = _a.sent();
                        return [2 /*return*/, respData];
                }
            });
        });
    };
    LeadRepository.prototype.checkPanDedupe = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, dedupeRes, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.checkPanDedupe);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        dedupeRes = _a.sent();
                        result = dedupeRes.data;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    LeadRepository.prototype.getPanMandatoryStatus = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, respData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.PanMandatoryCat);
                        if (req.CategoryId) {
                            url.searchParams.append("CategoryId", req.CategoryId.toString());
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        respData = _a.sent();
                        return [2 /*return*/, {
                                isPanMandatory: (respData === null || respData === void 0 ? void 0 : respData.data) !== null && (respData === null || respData === void 0 ? void 0 : respData.data) ? respData === null || respData === void 0 ? void 0 : respData.data : false,
                            }];
                }
            });
        });
    };
    LeadRepository.prototype.getSbCodes = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, respData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(leadUrlConfig.SBCodeMaster);
                        if (req.page) {
                            url.searchParams.append("page", req.page.toString());
                        }
                        if (req.pageSize) {
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        }
                        if (req.searchText && ((_a = req === null || req === void 0 ? void 0 : req.searchText) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            url.searchParams.append("searchText", req.searchText);
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        respData = _b.sent();
                        return [2 /*return*/, SBCodeMasterMapper(respData.data)];
                }
            });
        });
    };
    LeadRepository.prototype.getDIYSearchAOPLeadDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, respData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.DIY_SearchAOPLeadDetails);
                        if (req === null || req === void 0 ? void 0 : req.SearchText) {
                            url.searchParams.append("SearchText", req.SearchText.toString());
                        }
                        if (req.Page) {
                            url.searchParams.append("Page", req.Page.toString());
                        }
                        if (req.pageSize) {
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        respData = _a.sent();
                        return [2 /*return*/, DIYSearchAOPLeadDetailsMapper(respData)];
                }
            });
        });
    };
    LeadRepository.prototype.getPANVerificationStatusNew = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.panVerificationNew);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    LeadRepository.prototype.getPartnerCodes = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, respData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.partnerCodesNew);
                        if (req.page) {
                            url.searchParams.append("page", req.page.toString());
                        }
                        if (req.pageSize) {
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        }
                        if (req === null || req === void 0 ? void 0 : req.searchText) {
                            url.searchParams.append("searchText", req.searchText);
                        }
                        if (req === null || req === void 0 ? void 0 : req.LeadId) {
                            url.searchParams.append("LeadId", req.LeadId);
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        respData = _a.sent();
                        return [2 /*return*/, partnerCodeMapper(respData === null || respData === void 0 ? void 0 : respData.data)];
                }
            });
        });
    };
    LeadRepository.prototype.getCriticalfollowUpCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, respData, criticalFollowUpEntity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.getCriticalfollowUpCount);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        respData = _a.sent();
                        criticalFollowUpEntity = {
                            totalCount: 0,
                        };
                        if (respData && (respData === null || respData === void 0 ? void 0 : respData.data)) {
                            criticalFollowUpEntity.totalCount = respData === null || respData === void 0 ? void 0 : respData.data;
                        }
                        return [2 /*return*/, criticalFollowUpEntity];
                }
            });
        });
    };
    LeadRepository.prototype.getCategoryMasterData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, respData, productName;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(leadUrlConfig.categoryMasterLink);
                        if (req.Product && req.Product.length > 0) {
                            url.searchParams.append("Product", req.Product.join(","));
                        }
                        if (req.page) {
                            url.searchParams.append("page", req.page.toString());
                        }
                        if (req.pageSize) {
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        }
                        if (req.searchText) {
                            url.searchParams.append("searchText", req.searchText);
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        respData = _b.sent();
                        productName = {
                            productNameList: [],
                            filterData: [],
                        };
                        if (((_a = respData === null || respData === void 0 ? void 0 : respData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            productName.productNameList = respData.data;
                            productName.filterData = respData.data;
                        }
                        return [2 /*return*/, productName];
                }
            });
        });
    };
    LeadRepository.prototype.getProductNames = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, respData, productName;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(leadUrlConfig.ProductName);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        if (req.searchText) {
                            url.searchParams.append("searchText", req.searchText);
                        }
                        if (req.bucketlst && req.bucketlst.length > 0)
                            url.searchParams.append("bucketlst", req.bucketlst.join(","));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        respData = _b.sent();
                        productName = {
                            productNameList: [],
                            filterData: [],
                        };
                        if (((_a = respData === null || respData === void 0 ? void 0 : respData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            productName.productNameList = respData.data;
                            productName.filterData = respData.data;
                        }
                        return [2 /*return*/, productName];
                }
            });
        });
    };
    LeadRepository.prototype.getLeadPriority = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, respData, leadPriorityEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(leadUrlConfig.LeadPriority);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        respData = _b.sent();
                        leadPriorityEntity = {
                            leadPriority: [],
                        };
                        if (((_a = respData === null || respData === void 0 ? void 0 : respData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            leadPriorityEntity.leadPriority = respData.data;
                        }
                        return [2 /*return*/, leadPriorityEntity];
                }
            });
        });
    };
    LeadRepository.prototype.getSelfAssignDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, respData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.SelfAssign);
                        url.searchParams.append("LeadId", req.LeadId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                            })];
                    case 1:
                        respData = _a.sent();
                        return [2 /*return*/, SelfAssignMapper(respData)];
                }
            });
        });
    };
    LeadRepository.prototype.updateInternalComments = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, respData, internalComments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.internalComments);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        respData = _a.sent();
                        internalComments = {};
                        if (respData) {
                            internalComments = respData;
                        }
                        return [2 /*return*/, internalComments];
                }
            });
        });
    };
    LeadRepository.prototype.getSendVerificationLinkDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, respData, sendVerificationLinkEntity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.sendVerificationLink);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        respData = _a.sent();
                        sendVerificationLinkEntity = {};
                        if (respData.data) {
                            sendVerificationLinkEntity = respData.data;
                        }
                        return [2 /*return*/, sendVerificationLinkEntity];
                }
            });
        });
    };
    LeadRepository.prototype.getProductFeedbacks = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, respData, productFeedbackEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(leadUrlConfig.productFeedback);
                        url.searchParams.append("categoryId", req.categoryId.toString());
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        respData = _b.sent();
                        productFeedbackEntity = {
                            productFeedbacks: [],
                        };
                        if (((_a = respData === null || respData === void 0 ? void 0 : respData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            productFeedbackEntity.productFeedbacks = respData.data;
                        }
                        return [2 /*return*/, productFeedbackEntity];
                }
            });
        });
    };
    LeadRepository.prototype.sendProductPitchEmail = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, clickToCallResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.sendProductPitchEmail);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        clickToCallResponse = _a.sent();
                        return [2 /*return*/, clickToCallResponse.data];
                }
            });
        });
    };
    LeadRepository.prototype.clickToCall = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, clickToCallResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.clickToCall);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        clickToCallResponse = _a.sent();
                        return [2 /*return*/, clickToCallResponse.data.result];
                }
            });
        });
    };
    LeadRepository.prototype.getClientProfilePicture = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, reqObj, clientPictureData, clientProfilePicture;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.ProfilePic);
                        reqObj = "", clientPictureData = "";
                        if (!(req.type === "GET")) return [3 /*break*/, 2];
                        if (req.isGetAll) {
                            url = new URL(leadUrlConfig.ProfilePicAll);
                        }
                        if (req.isGetList) {
                            url = new URL(leadUrlConfig.ProfilePicList);
                        }
                        if (req.isGetAll || req.isGetList) {
                            url.searchParams.append("acCode", req.acCode);
                            url.searchParams.append("page", req.page.toString());
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        }
                        else if (req.isGetId) {
                            url = new URL(leadUrlConfig.ProfilePicId);
                            url.searchParams.append("fileId", req.fileid);
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        clientPictureData = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (req.type === "PUT") {
                            reqObj = { fileId: req.fileid, accode: req.acCode };
                        }
                        else if (req.type === "POST") {
                            reqObj = {
                                fileStream: req.fileStream,
                                accode: req.acCode,
                            };
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: req.type,
                                url: url.toString(),
                                body: reqObj,
                            })];
                    case 3:
                        clientPictureData = _a.sent();
                        _a.label = 4;
                    case 4:
                        clientProfilePicture = {};
                        clientProfilePicture.data = clientPictureData.data;
                        return [2 /*return*/, clientProfilePicture];
                }
            });
        });
    };
    // async getLeadLogsData(req: ILeadLogsReqPayload): Promise<ILeadLogsEntity> {
    //   const url = new URL(leadUrlConfig.leadLogs);
    //   url.searchParams.append("leadid", req.leadid);
    //   url.searchParams.append("page", req.page);
    //   url.searchParams.append("pageSize", req.pageSize);
    //   let leadLogs = await this.http.makeApiCall<ILeadLogsParams>({
    //     method: "GET",
    //     url: url.toString(),
    //   });
    //   let leadLogEntity: ILeadLogsEntity = {
    //     leadLogsList: [],
    //   };
    //   leadLogEntity.leadLogsList = leadLogs.data.result;
    //   return leadLogEntity;
    // }
    LeadRepository.prototype.getLeadLogsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, leadLogs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.leadLogs);
                        url.searchParams.append("LeadId", req.leadid);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        leadLogs = _a.sent();
                        return [2 /*return*/, leadLogsMapper(leadLogs.data)];
                }
            });
        });
    };
    LeadRepository.prototype.updateLead = function (leadObj) {
        return __awaiter(this, void 0, void 0, function () {
            var url, saveLead;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.updateLead);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: leadObj,
                            })];
                    case 1:
                        saveLead = _a.sent();
                        return [2 /*return*/, null];
                }
            });
        });
    };
    LeadRepository.prototype.saveLead = function (leadObj) {
        return __awaiter(this, void 0, void 0, function () {
            var url, saveLead;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.saveLead);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: leadObj,
                            })];
                    case 1:
                        saveLead = _a.sent();
                        return [2 /*return*/, saveLead.data];
                }
            });
        });
    };
    LeadRepository.prototype.getSearchLeadData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, searchData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.searchLead);
                        url.searchParams.append("searchText", req.searchText);
                        if ((req === null || req === void 0 ? void 0 : req.searchFor) !== null &&
                            (req === null || req === void 0 ? void 0 : req.searchFor) !== undefined &&
                            (req === null || req === void 0 ? void 0 : req.searchFor) !== "") {
                            url.searchParams.append("searchFor", req.searchFor);
                        }
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        if ((req === null || req === void 0 ? void 0 : req.partnerId) !== "" &&
                            (req === null || req === void 0 ? void 0 : req.partnerId) !== undefined &&
                            (req === null || req === void 0 ? void 0 : req.partnerId) !== null) {
                            url.searchParams.append("partnerId", req.partnerId);
                        }
                        if ((req === null || req === void 0 ? void 0 : req.partnercode) !== "" &&
                            (req === null || req === void 0 ? void 0 : req.partnercode) !== undefined &&
                            (req === null || req === void 0 ? void 0 : req.partnercode) !== null) {
                            url.searchParams.append("partnerCode", req.partnercode);
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        searchData = _a.sent();
                        // let searchData = dummySearchApiResponseData;
                        return [2 /*return*/, SearchLeadMapper(searchData)];
                }
            });
        });
    };
    LeadRepository.prototype.getClientProfileDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, clientProfileDetailsRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.clientProfileDetails);
                        url.searchParams.append("clientId", req.clientId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        clientProfileDetailsRes = _a.sent();
                        // let clientProfileDetailsRes: IClientProfileDetailsMainParams =
                        //   dummyClientProfileDetails;
                        return [2 /*return*/, ClientProfileDetailsMapper(clientProfileDetailsRes)];
                }
            });
        });
    };
    LeadRepository.prototype.getEmployeeList = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, employeeListReponse, employeeListEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.getEmployees);
                        url.searchParams.append("searchText", req.searchText);
                        url.searchParams.append("page", "1");
                        url.searchParams.append("pageSize", "100");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        employeeListReponse = _b.sent();
                        employeeListEntity = {
                            employeeListEntity: [],
                        };
                        if (((_a = employeeListReponse === null || employeeListReponse === void 0 ? void 0 : employeeListReponse.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            employeeListEntity.employeeListEntity = employeeListReponse.data;
                        }
                        return [2 /*return*/, employeeListEntity];
                }
            });
        });
    };
    LeadRepository.prototype.getLeadDashboard = function (req) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var localReqObj, url, leadDashboardReponse, leadDashboardEntity, Error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        localReqObj = JSON.parse(JSON.stringify(req));
                        if (localReqObj.isDateSkip) {
                            localReqObj.filterData.fromDate = null;
                            localReqObj.filterData.toDate = null;
                        }
                        if (!!localReqObj &&
                            !!localReqObj.filterData &&
                            ((_a = localReqObj.filterData) === null || _a === void 0 ? void 0 : _a.showAllOpenLeads)) {
                            localReqObj.filterData.fromDate = null;
                            localReqObj.filterData.toDate = null;
                        }
                        url = new URL(salesLeadUrlConfig.leadDetails);
                        localReqObj.filterData = removeObjectValues(localReqObj.filterData, /Lst/);
                        url.searchParams.append("filterdata", req.isExpiry
                            ? encodeURI(JSON.stringify({}))
                            : encodeURI(JSON.stringify(localReqObj.filterData)));
                        url.searchParams.append("flag", localReqObj.flag);
                        url.searchParams.append("isDownload", String(localReqObj.isDownload));
                        url.searchParams.append("page", localReqObj.page);
                        url.searchParams.append("pageSize", localReqObj.pageSize);
                        if (req.isExpiry) {
                            url.searchParams.append("isExpriry", String(req.isExpiry));
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        leadDashboardReponse = _c.sent();
                        leadDashboardEntity = {
                            leadDashboardList: [],
                        };
                        if (typeof (leadDashboardReponse === null || leadDashboardReponse === void 0 ? void 0 : leadDashboardReponse.data) === "string") {
                            leadDashboardEntity.leadDashboardBase64String =
                                leadDashboardReponse.data;
                        }
                        if (typeof (leadDashboardReponse === null || leadDashboardReponse === void 0 ? void 0 : leadDashboardReponse.data) !== "string" &&
                            ((_b = leadDashboardReponse === null || leadDashboardReponse === void 0 ? void 0 : leadDashboardReponse.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                            leadDashboardEntity.leadDashboardList = leadDashboardReponse.data.map(function (data) {
                                return __assign(__assign({}, data), { interactionStatus: !!data.interactionStatus
                                        ? data.interactionStatus
                                        : "", pipeline: !!data.pipeline ? Number(data.pipeline) : 0, status: !!data.status ? data.status : "", interaction_sub_status: !!data.interaction_sub_status
                                        ? data.interaction_sub_status
                                        : "", followupDate: !!data.followupDate ? data.followupDate : "" });
                            });
                        }
                        leadDashboardEntity.currentpage = leadDashboardReponse.currentpage;
                        leadDashboardEntity.totalitems = leadDashboardReponse.totalitems;
                        leadDashboardEntity.totalpages = leadDashboardReponse.totalpages;
                        return [2 /*return*/, leadDashboardEntity];
                    case 2:
                        Error_1 = _c.sent();
                        console.log(Error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LeadRepository.prototype.getLeadAddEditPage = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, profileData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.leadPastIntraction);
                        url.searchParams.append("AcCode", req.AcCode);
                        url.searchParams.append("mobno", req.mobno);
                        url.searchParams.append("emailid", req.emailid);
                        url.searchParams.append("Page", req.Page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        profileData = _a.sent();
                        //  let profileData = JSON.parse("clientRatingSummaryApiResponse");
                        return [2 /*return*/, leadPastInteractions(profileData.data)];
                }
            });
        });
    };
    LeadRepository.prototype.getLeadDBSummary = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.leadsummaryDB);
                        url.searchParams.append("filterdata", encodeURI(JSON.stringify(req.filterData)));
                        url.searchParams.append("status", req.status);
                        url.searchParams.append("page", "1");
                        url.searchParams.append("pageSize", "10");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    LeadRepository.prototype.getPurchaseHistory = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.leadPurchaseHistory);
                        url.searchParams.append("AcCode", req.clientId);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    LeadRepository.prototype.getViewLeadDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.viewLeadDetails);
                        url.searchParams.append("leadId", req.leadId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    LeadRepository.prototype.isAuthorizedToAssignLead = function (leadId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, authorizedToAssignLeadData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.resassignLeadCheck);
                        url.searchParams.append("LeadId", leadId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                            })];
                    case 1:
                        authorizedToAssignLeadData = _a.sent();
                        return [2 /*return*/, authorizedToAssignLeadData];
                }
            });
        });
    };
    LeadRepository.prototype.reassignLead = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, reassignToLead;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.reassignTask);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        reassignToLead = _a.sent();
                        //let reassignToLead = JSON.parse(reassignLead);
                        return [2 /*return*/, reassignToLead.data.response === "Success" ? true : false];
                }
            });
        });
    };
    LeadRepository.prototype.editAccessLead = function (req) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var url, editLeadParams;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.editLeadAccess);
                        if (!!req.strLeadId && ((_a = req === null || req === void 0 ? void 0 : req.strLeadId) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            url.searchParams.append("strLeadId", req.strLeadId);
                        }
                        if (!!req.strFlag && ((_b = req === null || req === void 0 ? void 0 : req.strFlag) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                            url.searchParams.append("strFlag", req.strFlag);
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        editLeadParams = _c.sent();
                        //let reassignToLead = JSON.parse(reassignLead);
                        return [2 /*return*/, editLeadParams.data];
                }
            });
        });
    };
    LeadRepository.prototype.getChildLeadData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, childLeadData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("childLeadData", salesLeadUrlConfig.childLeadData);
                        url = new URL(salesLeadUrlConfig.childLeadData);
                        url.searchParams.append("strLeadId", req.leadId);
                        console.log("childLeadData", url);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        childLeadData = _a.sent();
                        console.log("childLeadData", childLeadData);
                        return [2 /*return*/, { childData: childLeadData }];
                }
            });
        });
    };
    LeadRepository.prototype.getViewLeadData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, viewLeadData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.viewLeadDetails);
                        url.searchParams.append("leadId", req.LeadId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        viewLeadData = _a.sent();
                        // let viewLeadData = JSON.parse(viewLead);
                        return [2 /*return*/, { data: viewLeadData.data }];
                }
            });
        });
    };
    LeadRepository.prototype.getViewEditLeadData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, viewLeadData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.viewEditLeadDetails);
                        url.searchParams.append("leadId", req.LeadId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        viewLeadData = _a.sent();
                        // let viewLeadData = JSON.parse(viewLead);
                        return [2 /*return*/, { data: viewLeadData.data }];
                }
            });
        });
    };
    LeadRepository.prototype.getValidateOtp = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, requestid, otpId, encryptedString, headers, result, decryptedString, decryptedObj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.validateotpEncrypted);
                        requestid = generateRandomString();
                        otpId = req.otpId;
                        req.hashStr = generateHashForHmacSHA256(requestid, req.otpId + req.otp);
                        encryptedString = genericEncrypt(process.env.AES_KEY, process.env.AES_IV, JSON.stringify(req), 32);
                        headers = new Headers();
                        headers.append("requestid", requestid);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: { request: encryptedString },
                                headers: headers,
                            })];
                    case 1:
                        result = _a.sent();
                        decryptedString = genericDecrypt(process.env.AES_KEY, process.env.AES_IV, result.data, 32);
                        decryptedObj = JSON.parse(decryptedString);
                        return [2 /*return*/, validateOtpMapper(decryptedObj, generateHashForHmacSHA256(requestid, otpId))];
                }
            });
        });
    };
    LeadRepository.prototype.getLeadOtp = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, body, leadOtp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.leadOtp);
                        body = __assign({}, req);
                        if (process.env.NODE_ENV === "uat" ||
                            process.env.NODE_ENV === "development") {
                            //only for UAT for Testing purpose
                            body.envtype = "uat";
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: body,
                            })];
                    case 1:
                        leadOtp = _a.sent();
                        return [2 /*return*/, LeadOtpMapper(leadOtp.data)];
                }
            });
        });
    };
    LeadRepository.prototype.updateClientRegistration = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, updateClientDetails, responseData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.updateClientRegistration);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        updateClientDetails = _a.sent();
                        responseData = updateClientDetails.data.response === "Success" ? true : false;
                        return [2 /*return*/, {
                                data: responseData,
                                responseDescription: updateClientDetails.data.response !== "Success"
                                    ? updateClientDetails.data.responseDescription
                                    : "",
                            }];
                }
            });
        });
    };
    LeadRepository.prototype.savePartnerUPC = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, updateClientDetails, responseData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.PartnerUPC);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        updateClientDetails = _a.sent();
                        responseData = updateClientDetails.data.response === "Success" ? true : false;
                        return [2 /*return*/, {
                                data: responseData,
                                responseDescription: updateClientDetails.data.response !== "Success"
                                    ? updateClientDetails.data.responseDescription
                                    : "",
                            }];
                }
            });
        });
    };
    LeadRepository.prototype.leadsPitchProd = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, leadsPitchProd;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.leadsPitch);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        leadsPitchProd = _a.sent();
                        return [2 /*return*/, leadsPitchProd.data];
                }
            });
        });
    };
    LeadRepository.prototype.getInternalComments = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, leadsPitchProd;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.leadsComments);
                        url.searchParams.append("LeadId", req.leadId);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        leadsPitchProd = _a.sent();
                        return [2 /*return*/, internalCommentMapper(leadsPitchProd)];
                }
            });
        });
    };
    LeadRepository.prototype.getLeadRedirection = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, leadsPitchProd;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.leadRedirection);
                        url.searchParams.append("LeadId", req.leadId);
                        if (req.orderId !== null &&
                            req.orderId !== undefined &&
                            req.orderId !== "Initiate")
                            url.searchParams.append("OrderId", req.orderId);
                        url.searchParams.append("LeadSource", req.leadSource);
                        url.searchParams.append("email", req.email);
                        url.searchParams.append("mobile", req.mobile);
                        url.searchParams.append("product", req.product);
                        url.searchParams.append("category", req.category);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        leadsPitchProd = _a.sent();
                        return [2 /*return*/, leadsPitchProd.data];
                }
            });
        });
    };
    LeadRepository.prototype.checkDedupe = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, dedupeRes, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.checkDedupe);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        dedupeRes = _a.sent();
                        result = __assign(__assign({}, dedupeRes), { isDedup: dedupeRes.isDedup === "N" ? false : true, isFamilyTagging: dedupeRes.isFamilyTagging === "N" ? false : true });
                        return [2 /*return*/, result];
                }
            });
        });
    };
    LeadRepository.prototype.checkPartnerDedupe = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.checkPartnerDedupe);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        response = _a.sent();
                        result = __assign(__assign({}, response), { isDedup: response.isDedup === "N" ? false : true, isFamilyTagging: response.isFamilyTagging === "N" ? false : true });
                        return [2 /*return*/, result];
                }
            });
        });
    };
    LeadRepository.prototype.getPANVerificationStatus = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.panVerification);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    LeadRepository.prototype.getValidationPipelineAmount = function (req) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = new URL(leadUrlConfig.validationPipelineAmount);
                        url.searchParams.append("assetId", (_a = req === null || req === void 0 ? void 0 : req.assetId) === null || _a === void 0 ? void 0 : _a.toString());
                        url.searchParams.append("productId", (_b = req === null || req === void 0 ? void 0 : req.productId) === null || _b === void 0 ? void 0 : _b.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _c.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    LeadRepository.prototype.clientProfileUpdate = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.clientProfileUpdate);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LeadRepository.prototype.getCriticalPriorityAging = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.criticalPriorityAging);
                        url.searchParams.append("page", "1");
                        url.searchParams.append("pageSize", "100");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, CriticalPriorityAgingMapper(response)];
                }
            });
        });
    };
    LeadRepository.prototype.checkUccStatus = function (_a) {
        var source = _a.source, uccCode = _a.uccCode;
        return __awaiter(this, void 0, void 0, function () {
            var url, headers, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(leadUrlConfig.UccStatus);
                        headers = new Headers();
                        headers.append("ApiKey", leadStatusConfig.ApiKey);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: { source: source, uccCode: uccCode },
                                headers: headers,
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    LeadRepository.prototype.checkUccDedup = function (_a) {
        var mobile = _a.mobile, email = _a.email, source = _a.source;
        return __awaiter(this, void 0, void 0, function () {
            var url, headers, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(leadUrlConfig.UccDedup);
                        headers = new Headers();
                        headers.append("ApiKey", leadStatusConfig.ApiKey);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: { mobile: mobile, email: email, source: source },
                                headers: headers,
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    LeadRepository.prototype.clientEmailUpdate = function (_a) {
        var email = _a.email, uccCode = _a.uccCode, source = _a.source;
        return __awaiter(this, void 0, void 0, function () {
            var url, headers, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(leadUrlConfig.EmailUpdate);
                        headers = new Headers();
                        headers.append("ApiKey", leadStatusConfig.ApiKey);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: { email: email, uccCode: uccCode, source: source },
                                headers: headers,
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    LeadRepository.prototype.clientPanUpdate = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, headers, response, requiredResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(leadUrlConfig.PanUpdate);
                        headers = new Headers();
                        headers.append("ApiKey", leadStatusConfig.ApiKey);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                headers: headers,
                            })];
                    case 1:
                        response = _a.sent();
                        requiredResponse = {
                            success: response.success,
                            data: response.data,
                        };
                        return [2 /*return*/, requiredResponse];
                }
            });
        });
    };
    LeadRepository.prototype.getViewEditMultipleLeadsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, viewLeadData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.viewEditMultipleLeadsDetails);
                        if (req.LeadId)
                            url.searchParams.append("leadId", req.LeadId);
                        if (req.accode)
                            url.searchParams.append("accode", req.accode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        viewLeadData = _a.sent();
                        return [2 /*return*/, viewLeadData];
                }
            });
        });
    };
    LeadRepository.prototype.checkMomStatus = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, momStatusData, dataToBeReturned;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.checkMomStatus);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        momStatusData = _a.sent();
                        dataToBeReturned = {
                            data: momStatusData.data,
                            message: momStatusData === null || momStatusData === void 0 ? void 0 : momStatusData.message,
                        };
                        return [2 /*return*/, dataToBeReturned];
                }
            });
        });
    };
    LeadRepository.prototype.sendViewMomTemplate = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, sendViewMomTemplateData, dataToBeReturned;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.sendViewMomTemplate);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        sendViewMomTemplateData = _a.sent();
                        dataToBeReturned = {
                            success: sendViewMomTemplateData === null || sendViewMomTemplateData === void 0 ? void 0 : sendViewMomTemplateData.success,
                            message: sendViewMomTemplateData === null || sendViewMomTemplateData === void 0 ? void 0 : sendViewMomTemplateData.message,
                            data: sendViewMomTemplateData === null || sendViewMomTemplateData === void 0 ? void 0 : sendViewMomTemplateData.data,
                        };
                        return [2 /*return*/, dataToBeReturned];
                }
            });
        });
    };
    LeadRepository.prototype.editMomTemplate = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.editMomTemplate);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LeadRepository.prototype.getMomAttachFiles = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.getMomAttachFiles);
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        if (req === null || req === void 0 ? void 0 : req.filename)
                            url.searchParams.append("filename", req.filename);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, momAttachFilesMapper(response)];
                }
            });
        });
    };
    LeadRepository.prototype.getMomDownloadAttachFile = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.momDownloadFile);
                        url.searchParams.append("fileKey", req.fileKey);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LeadRepository.prototype.getViewMomDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.viewMomDetails);
                        url.searchParams.append("leadid", req.leadid);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LeadRepository.prototype.getViewMomAttachmentDownload = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(salesLeadUrlConfig.viewMomAttachmentDownload);
                        url.searchParams.append("documentId", (_a = req.documentId) === null || _a === void 0 ? void 0 : _a.toString());
                        url.searchParams.append("fileTag", req.fileTag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    return LeadRepository;
}());
export default LeadRepository;
